import api from "@/lib/api";

const CHUNK_BYTES = 2 * 1024 * 1024;

const blobToBase64 = (blob) =>
  new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(String(r.result).split(",")[1]);
    r.onerror = rej;
    r.readAsDataURL(blob);
  });

export async function uploadVideo({ inspectionId, itemId, blob, mime, duration, onProgress }) {
  const ext = mime.includes("mp4") ? "mp4" : "webm";
  const filename = `clip-${new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-")}.${ext}`;
  const init = await api.post(`/inspections/${inspectionId}/videos/init`, {
    item_id: itemId, filename, mime, total_size: blob.size,
  });
  const videoId = init.data.video_id;
  const total = Math.ceil(blob.size / CHUNK_BYTES);
  for (let i = 0; i < total; i++) {
    const slice = blob.slice(i * CHUNK_BYTES, (i + 1) * CHUNK_BYTES);
    const data_base64 = await blobToBase64(slice);
    await api.post(`/inspections/${inspectionId}/videos/${videoId}/chunk`, { index: i, data_base64 });
    onProgress?.(Math.round(((i + 1) / total) * 95));
  }
  const done = await api.post(`/inspections/${inspectionId}/videos/${videoId}/complete`, {
    duration_seconds: duration,
  });
  onProgress?.(100);
  return done.data;
}

export const fmtClipDuration = (s) => `${Math.floor(s / 60)}:${String(Math.round(s % 60)).padStart(2, "0")}`;
